import {
    createSlice,
} from '@reduxjs/toolkit'
import { BUILDING_TYPES } from '../constants/core'

const initalState = {
    actives: [
        BUILDING_TYPES.GOVERNMENT_OFFICE,
        BUILDING_TYPES.COMMUNITY_HALL,
        BUILDING_TYPES.QUARTERS,
        BUILDING_TYPES.HKO_STATION,
        BUILDING_TYPES.GOVERNMENT_SCHOOL,
        BUILDING_TYPES.JUDICIARY,
        BUILDING_TYPES.HEALTH
    ]
}

const buildingTypesSlice = createSlice({
    name: 'building_types',
    initialState: initalState,
    reducers: {
        changeBuildingTypes(state, {payload: building_types}) {
            state.actives = building_types
        }
    },
})

export default buildingTypesSlice.reducer

export const {changeBuildingTypes} = buildingTypesSlice.actions;